module.exports = __webpack_public_path__ + "static/media/ams-success-img-navy-blue.ad0f1de0.png";